<script setup lang="ts">
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel/dist/carousel.es.js'
import { computed } from 'vue'
import { useIdeStore } from '@/stores/ide.store'
import { IDEVIEWTABS_MOBILE } from '@/utils/tabs'
import jdroidLogo from '@/assets/images/ide/ai/jdroid-icon.svg'
interface IMoibileTab {
  title: string
  id: string
}

const isDefaultIde = computed(() => {
  return ideStore.isDefaultIde
})
const isBlockly = computed(() => {
  return ideStore.isBlockly
})
const isHtml = computed(() => {
  return ideStore.isHtml
})

const isAdvancedCompiler = computed(() => {
  return ideStore.isAdvancedCompiler
})

const isDataBaseView = computed(() => {
  return ideStore.isAdvancedCompilerDatabase
})

const tabs = computed<IMoibileTab[]>(() => {
  let tabs = []

  if (isDefaultIde.value) {
    tabs = [
      { title: 'Code editor', id: IDEVIEWTABS_MOBILE.IDE },
      { title: 'Social share', id: IDEVIEWTABS_MOBILE.SOCIALSHARE }
    ]
  } else if (isShowLibs.value) {
    tabs = [
      { title: 'Code editor', id: IDEVIEWTABS_MOBILE.IDE },
      { title: 'JDroid AI', id: IDEVIEWTABS_MOBILE.JDROID },
      { title: 'External libraries', id: IDEVIEWTABS_MOBILE.LIBRARIES },
      { title: 'Upload files', id: IDEVIEWTABS_MOBILE.INPUTFILES },
      { title: 'Input', id: IDEVIEWTABS_MOBILE.INPUT },
      { title: 'Output', id: IDEVIEWTABS_MOBILE.OUTPUT },
      { title: 'Social share', id: IDEVIEWTABS_MOBILE.SOCIALSHARE },
      { title: 'API tester', id: IDEVIEWTABS_MOBILE.APITAB }
    ]
  } else if (isHtml.value) {
    tabs = [
      { title: 'Code editor', id: IDEVIEWTABS_MOBILE.IDE },
      { title: 'Output', id: IDEVIEWTABS_MOBILE.OUTPUTHTML },
      { title: 'API tester', id: IDEVIEWTABS_MOBILE.APITAB }
    ]
  } else if (isBlockly.value) {
    tabs = [
      { title: 'Code editor', id: IDEVIEWTABS_MOBILE.IDE },
      { title: 'Upload files', id: IDEVIEWTABS_MOBILE.INPUTFILES },
      { title: 'Input', id: IDEVIEWTABS_MOBILE.INPUT },
      { title: 'Output', id: IDEVIEWTABS_MOBILE.OUTPUT },
      { title: 'Social share', id: IDEVIEWTABS_MOBILE.SOCIALSHARE },
      { title: 'API tester', id: IDEVIEWTABS_MOBILE.APITAB }
    ]
  } else if (isAdvancedCompiler.value) {
    tabs = [
      { title: 'Code editor', id: IDEVIEWTABS_MOBILE.IDE },
      { title: 'JDroid AI', id: IDEVIEWTABS_MOBILE.JDROID },
      { title: 'API tester', id: IDEVIEWTABS_MOBILE.APITAB },
      { title: 'Browser', id: IDEVIEWTABS_MOBILE.OUTPUTHTML },
      { title: 'Terminal', id: IDEVIEWTABS_MOBILE.TERMINAL },
      { title: 'Console', id: IDEVIEWTABS_MOBILE.CONSOLE }
    ]
  } else if (isDataBaseView.value) {
    tabs = [
      { title: 'Code editor', id: IDEVIEWTABS_MOBILE.IDE },
      { title: 'JDroid AI', id: IDEVIEWTABS_MOBILE.JDROID },
      { title: 'Console', id: IDEVIEWTABS_MOBILE.DB_TERMINAL },
      { title: 'API tester', id: IDEVIEWTABS_MOBILE.APITAB }
    ]
  } else {
    tabs = [
      { title: 'Code editor', id: IDEVIEWTABS_MOBILE.IDE },
      { title: 'JDroid AI', id: IDEVIEWTABS_MOBILE.JDROID },
      { title: 'Upload files', id: IDEVIEWTABS_MOBILE.INPUTFILES },
      { title: 'Input', id: IDEVIEWTABS_MOBILE.INPUT },
      { title: 'Output', id: IDEVIEWTABS_MOBILE.OUTPUT },
      { title: 'Social share', id: IDEVIEWTABS_MOBILE.SOCIALSHARE },
      { title: 'API tester', id: IDEVIEWTABS_MOBILE.APITAB }
    ]
  }

  return tabs
})

const ideStore = useIdeStore()

/**
 * @param tabId id of tab selected
 */
function handleSelectMobileTab(tabId: string) {
  ideStore.setMobileTab(tabId)
}

const isShowLibs = computed(() => {
  return ideStore.ideMeta?.isPlus && ideStore.ideMeta?.library
})
</script>

<template>
  <div class="section-quinary carousel-container h-full w-full">
    <div class="block sm:hidden" id="mobileIdeTabs">
      <nav class="w-full">
        <carousel
          :items-to-show="2"
          snap-align="center-even"
          :wrap-around="false"
          class="mx-auto w-[calc(100%-80px)]"
        >
          <slide v-for="(tab, idx) in tabs" :key="idx" class="w-full">
            <button
              type="button"
              class="inline-flex h-full w-full items-center justify-center gap-1 whitespace-nowrap py-4 text-sm"
              :class="tab.id == ideStore.currentMobileTab ? 'section-primary' : 'section-qinary'"
              :id="`${tab.id}-item`"
              @click="handleSelectMobileTab(tab.id)"
            >
              <img v-if="tab.title == 'JDroid AI'" :src="jdroidLogo" class="w-6" />
              {{ tab.title }}
            </button>
          </slide>

          <!-- Arrow buttons -->
          <template #addons>
            <navigation>
              <template #next>
                <FontAwesomeIcon icon="fa-caret-right" class="text-[#9FB1D1]" />
              </template>

              <template #prev>
                <FontAwesomeIcon icon="fa-caret-left" class="text-[#9FB1D1]" />
              </template>
            </navigation>
          </template>
        </carousel>
      </nav>
    </div>
  </div>
</template>

<style>
#mobileIdeTabs .carousel__prev {
  left: -40px;
}

#mobileIdeTabs .carousel__next {
  right: -40px;
}

#mobileIdeTabs .carousel__prev,
#mobileIdeTabs .carousel__next {
  /* background-color: red; */
  border-radius: 0;
  margin: 0;
  @apply bg-background-quaternary dark:bg-background-quaternary-dark;
  height: 100%;
  width: 40px;
}
</style>
